import { SelectLand } from '@ts/components/SelectLand';

export const init = () => {
    setSelectFilters(document);
    setHTMXListeners();
}

const setSelectFilters = (root) => {
    SelectLand.create('#product-sort-filter', {
        prefix: 'Sort by: '
    });
}

const setHTMXListeners = () => {
    document.body.addEventListener('htmx:afterSettle', (event) => setSelectFilters(event.target));
}